var _linearGradient, _clipPath, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 20,
    role: "img",
    "aria-label": "Firebase",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Firebase") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 75,
    height: 20,
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDAwMDAwIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+RmlyZWJhc2U8L3RpdGxlPjxwYXRoIGQ9Ik0zLjg5IDE1LjY3Mkw2LjI1NS40NjFBLjU0Mi41NDIgMCAwMTcuMjcuMjg4bDIuNTQzIDQuNzcxem0xNi43OTQgMy42OTJsLTIuMjUtMTRhLjU0LjU0IDAgMDAtLjkxOS0uMjk1TDMuMzE2IDE5LjM2NWw3Ljg1NiA0LjQyN2ExLjYyMSAxLjYyMSAwIDAwMS41ODggMHpNMTQuMyA3LjE0N2wtMS44Mi0zLjQ4MmEuNTQyLjU0MiAwIDAwLS45NiAwTDMuNTMgMTcuOTg0eiIvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 465,
    y: 150,
    fill: "#ccc",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 470
  }, "Firebase"), /*#__PURE__*/React.createElement("text", {
    x: 465,
    y: 140,
    transform: "scale(.1)",
    fill: "#333",
    textLength: 470
  }, "Firebase"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.8822d1807d53bf13d94bae23e9054539.svg";
export { ForwardRef as ReactComponent };